import { Store } from '@ngrx/store';
import { setFundChartPartner } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/partner/partner.actions';
import { setFundChartSecuritylistSecurityId } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securitylist-security-id/security-list-security-id.actions';
import { hasValidRequestData } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.selectors';
import { DOWNLOAD, EMBED_TYPE_IMAGE_CODE, PRINT } from 'Angular/constants/core.constants';
import { FUND_CHART_CREATOR_EXPORT_OPTIONS, PARTNER_CHART_SIZES } from 'ChartApp/ts/apps/fund-chart-creator/constants';
import { Partner, } from 'ChartApp/ts/apps/fund-chart-creator/interfaces/fund-chart-creator.interface';
import { YChartsSentryUtils } from 'Angular/services/sentry/sentry-utils';
import { FundChartCreatorAppStateManager } from 'ChartApp/ts/apps/fund-chart-creator/services/fund-chart-creator-app.service';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ChartCreatorEmbedModalComponent } from 'ChartApp/ts/apps/fund-chart-creator/components/chart-creator-embed-modal/chart-creator-embed-modal.component';
import ChartImageHelper from 'ChartApp/ts/features/fundamental-chart/chart-image-helper';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/apps/fund-chart-creator/services/fund-chart-creator-app.service";
import * as i2 from "ChartApp/ts/services/fund-chart.service";
import * as i3 from "@ngrx/store";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i6 from "../chart-creator-embed-modal/chart-creator-embed-modal.component";
const _c0 = ["chartCreatorEmbedModalComponent"];
const _c1 = a0 => ({ disabled: a0 });
export class FundChartCreatorHeaderComponent {
    constructor(fundChartCreatorAppStateService, fundChartService, store) {
        this.fundChartCreatorAppStateService = fundChartCreatorAppStateService;
        this.fundChartService = fundChartService;
        this.store = store;
        this.chartHasValidRequestData = false;
        this.exportOptions = FUND_CHART_CREATOR_EXPORT_OPTIONS;
        this.mapStateToComponent = (state) => {
            const chartHasValidRequestData = hasValidRequestData(state);
            const { fundChart } = state;
            this.chartHasValidRequestData = !!chartHasValidRequestData;
            this.embedCodeUrl = chartHasValidRequestData
                ? this.fundChartService.getChartEmbedUrl(fundChart, EMBED_TYPE_IMAGE_CODE)
                : null;
            this.fundChartCreatorState = fundChart;
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    showEmbedModal() {
        if (this.chartHasValidRequestData) {
            this.chartCreatorEmbedModalComponent.openModal();
        }
    }
    setChartPartner(partner) {
        this.store.dispatch(setFundChartPartner({ partner }));
    }
    resetChart() {
        // We set chartView and securitylistSecurityId to their default since those two fields are not part of
        // state that is saved to the database. resetAppStateToSystemDefault only resets those fields which
        // are saved to the database in the `state` field. Eventually we will want to abstract this out into a
        // pattern where the set of fields that need to reset that are not part of the `saved state` will
        // automatically be reset. Also see the first case statement of the `switch (item.itemType)` in saved_item_dropdown.component.js
        // as another example of where we need ot update both of these fields since they are not part of the
        // fields that are saved to the db.
        this.store.dispatch(setFundChartSecuritylistSecurityId({ securitylistSecurityId: '' }));
        this.fundChartCreatorAppStateService.resetToSystemDefault();
        // reset partner from angular binding
        const sizesByPartner = PARTNER_CHART_SIZES[this.partnerId];
        this.setChartPartner(sizesByPartner[0].value);
    }
    exportHandler(selectedItem) {
        this.fundChartService.getChartSaveAsImageUrl(this.fundChartCreatorState).subscribe({
            next: (response) => {
                if (response.ok && response.body) {
                    switch (selectedItem) {
                        case DOWNLOAD:
                            new ChartImageHelper(response.body.image_url).download();
                            break;
                        case PRINT:
                            new ChartImageHelper(response.body.image_url).print(null);
                            break;
                        default:
                            break;
                    }
                }
            },
            error: (err) => {
                YChartsSentryUtils.captureException(err);
            },
        });
    }
}
FundChartCreatorHeaderComponent.ɵfac = function FundChartCreatorHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCreatorHeaderComponent)(i0.ɵɵdirectiveInject(i1.FundChartCreatorAppStateManager), i0.ɵɵdirectiveInject(i2.FundChartService), i0.ɵɵdirectiveInject(i3.Store)); };
FundChartCreatorHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartCreatorHeaderComponent, selectors: [["ycn-fund-chart-creator-header"]], viewQuery: function FundChartCreatorHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartCreatorEmbedModalComponent = _t.first);
    } }, inputs: { partnerId: "partnerId" }, standalone: false, decls: 18, vars: 9, consts: [["chartCreatorEmbedModalComponent", ""], [1, "page-title", "col-5", "col-md-7"], [1, "page-name"], [1, "page-name-text"], [1, "page-header-actions", "align-self-center"], ["buttonClass", "btn btn-transparent2 dropdown-toggle", 1, "page-header-action", "dropdown", 3, "handler", "config", "inputDisabled", "dropdownClass"], [1, "page-header-action", "user-select-none"], [1, "btn", "btn-transparent2", 3, "click"], ["ycnIcon", "", "name", "icon-embed"], ["ycnIcon", "", "name", "icon-reset"], [3, "embedCodeUrl", "partnerId"]], template: function FundChartCreatorHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
        i0.ɵɵtext(3, "Fundamental Chart Creator");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(4, "div", 4)(5, "ycn-simple-dropdown", 5);
        i0.ɵɵlistener("handler", function FundChartCreatorHeaderComponent_Template_ycn_simple_dropdown_handler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6)(7, "a", 7);
        i0.ɵɵlistener("click", function FundChartCreatorHeaderComponent_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showEmbedModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 8);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "span");
        i0.ɵɵtext(10, "Embed");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 6)(12, "a", 7);
        i0.ɵɵlistener("click", function FundChartCreatorHeaderComponent_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.fundChartCreatorAppStateService.resetToSystemDefault()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(13, "svg", 9);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15, "Reset All");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(16, "ycn-chart-creator-embed-modal", 10, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("config", ctx.exportOptions)("inputDisabled", !ctx.chartHasValidRequestData)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(7, _c1, !ctx.chartHasValidRequestData));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("embedCodeUrl", ctx.embedCodeUrl)("partnerId", ctx.partnerId);
    } }, dependencies: [i4.IconDirective, i5.SimpleDropdownComponent, i6.ChartCreatorEmbedModalComponent], encapsulation: 2 });
